import type { FC } from "react";
import { usePopover } from "../../../../utils/hooks/use-popover";
import { ColourPickerV2 } from "./colour-picker-v2";

export const ColourPicker: FC<{
  popover: ReturnType<typeof usePopover<HTMLElement>>;
  onChange: (color: string, skipAddingToHistoryStack?: boolean) => void;
  colour: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}> = ({ popover, onChange, colour, inputRef }) => {
  return (
    <ColourPickerV2 popover={popover} onChange={onChange} colour={colour} inputRef={inputRef} />
  );
};
